<div fxLayout="row" fxLayoutAlign="start start">
  <mat-card [fxFlex]="companyEntity ? 50 : 100">
    <mat-card-content>
      <div *ngIf="companyEntity" class="m-b-10" fxLayout="row" fxLayoutAlign="space-between center">
        <div>
          <img class="product-company-logo" *ngIf="getCompanyLogo(companyEntity?.id)"
            [lazyLoad]="getCompanyLogo(companyEntity?.id)">
          <div fxLayout="column" fxLayoutAlign="center start" fxLayoutAlign.lt-sm="center center">
            <span [ngClass.lt-sm]="{'card-title': true}" [matTooltip]="companyEntity?.id">{{ companyEntity?.name
              }}</span>
            <small class="text-info">{{ companyTypes[companyEntity.type] }}</small>
          </div>
        </div>
        <div>
          <button mat-icon-button>
            <mat-icon *ngIf="editCollapsed" matTooltip="Edit Company" color="accent"
              (click)="editCollapsed = false">edit</mat-icon>
            <mat-icon *ngIf="!editCollapsed" matTooltip="Cancel Edit" color="basic"
              (click)="editCollapsed = true">clear</mat-icon>
          </button>
        </div>
      </div>
      <form [fxShow]="!editCollapsed || !companyEntity" [formGroup]="manufacturerForm" (ngSubmit)="onSubmit()">
        <div fxLayout="row wrap" fxFlexAlign="center" class="row">
          <mat-form-field fxFlex.gt-sm="50" fxFlex="100" class="p-10">
            <mat-label>Name</mat-label>
            <input type="text" matInput formControlName="name" placeholder="Company Name">
            <mat-error *ngIf="form.name.hasError('required')">
              Name is <strong>required</strong>
            </mat-error>
          </mat-form-field>
          <mat-form-field fxFlex.gt-sm="50" fxFlex="100" class="p-10">
            <mat-label>Code</mat-label>
            <input type="text" matInput formControlName="code" placeholder="Code">
            <mat-error *ngIf="form.code.hasError('required')">
              Code is <strong>required</strong>
            </mat-error>
          </mat-form-field>
          <mat-form-field fxFlex.gt-sm="50" fxFlex="100" class="p-10">
            <input matInput type="text" placeholder="Parent company" matInput formControlName="parentCompanyId"
              [matAutocomplete]="companyAuto">
            <mat-autocomplete #companyAuto="matAutocomplete" [displayWith]="displayCompanyName">
              <mat-option *ngFor="let company of filteredCompanies | async" [value]="company.id">
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                  <img class="company-logo" *ngIf="company?.logoUrl" [lazyLoad]="company.logoUrl"
                    [matTooltip]="company.name" />
                  <span [innerHtml]="company.name | highlight: companyControl.value"></span>
                </div>
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
          <mat-form-field fxFlex.gt-sm="50" fxFlex="100" class="p-10">
            <mat-label>Locale</mat-label>
            <input type="text" matInput formControlName="locale" placeholder="Locale">
          </mat-form-field>
          <mat-form-field fxFlex.gt-sm="50" fxFlex="100" class="p-10">
            <mat-label>TimeZone</mat-label>
            <input type="text" matInput formControlName="timeZone" placeholder="TimeZone">
          </mat-form-field>
          <mat-form-field fxFlex.gt-sm="50" fxFlex="100" class="p-10">
            <mat-label>Type</mat-label>
            <mat-select matInput formControlName="type" placeholder="Type">
              <mat-option [value]="0">Builder</mat-option>
              <mat-option [value]="1">Manufacturer</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field fxFlex="100" class="p-10">
            <mat-label>Website</mat-label>
            <input type="text" matInput formControlName="website" placeholder="Website">
          </mat-form-field>
          <mat-form-field fxFlex="100" class="p-10">
            <mat-label>Logo URL</mat-label>
            <input type="text" matInput formControlName="logoUrl" placeholder="Logo URL">
          </mat-form-field>
        </div>
        <div fxLayoutAlign="end center" fxLayoutGap="15px">
          <button type="submit" matTooltip="Save Changes" class="add-action-button" mat-flat-button color="primary"
            [disabled]="!manufacturerForm.valid">
            <mat-icon>done</mat-icon>Save
          </button>
          <button type="button" matTooltip="Return to Company List" class="reset-button" mat-stroked-button
            color="basic" (click)="showManufacturersView()">
            <mat-icon>clear</mat-icon>Back
          </button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
  <mat-card *ngIf="companyEntity" fxFlex="50">
    <mat-card-content fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="10px">
      <mat-card class="w-100">
        <mat-card-content fxLayout="column" fxLayoutAlign="center center">
          <div class="text-info m-b-20 display-number">
            {{ userCount }}
          </div>
          <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px">
            <span>Users</span>
            <a [routerLink]="['/admin/user']" mat-icon-button color="accent" matTooltip="Manage Users">
              <mat-icon>settings</mat-icon>
            </a>
          </div>
        </mat-card-content>
      </mat-card>
      <mat-card *ngIf="homeCount > 0" class="w-100">
        <mat-card-content fxLayout="column" fxLayoutAlign="center center">
          <div class="text-info m-b-20 display-number">
            {{ homeCount }}
          </div>
          <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px">
            <span>Homes</span>
            <a [routerLink]="['/homes/dashboard']" mat-icon-button color="accent" matTooltip="Manage Homes">
              <mat-icon>settings</mat-icon>
            </a>
          </div>
        </mat-card-content>
      </mat-card>
      <mat-card *ngIf="productCount > 0" class="w-100">
        <mat-card-content fxLayout="column" fxLayoutAlign="center center">
          <div class="text-info m-b-20 display-number">
            {{ productCount }}
          </div>
          <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px">
            <span>Products</span>
            <a [routerLink]="['/products/catalog']" [queryParams]="{ company: id }" mat-icon-button color="accent"
              matTooltip="Manage Products">
              <mat-icon>settings</mat-icon>
            </a>
          </div>
        </mat-card-content>
      </mat-card>
      <mat-card *ngIf="(productCount > 0) && !marketingPanels?.length" class="w-100">
        <mat-card-content fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="10px">
          <button mat-stroked-button type="submit" (click)="newReferenceInput.click()">
            Upload Marketing Panel(s)
            <input #newReferenceInput class="upload-input" id="add-new-reference-item" type="file" multiple
              (change)="onFileChosen($event)" onclick="value = null" [accept]="acceptedTypes.join(',')">
          </button>
          <mat-icon color="accent"
            matTooltip="Upload one or more company-wide marketing panels for use in product callouts. These will be used instead of dynamically generated panels.">info</mat-icon>
        </mat-card-content>
      </mat-card>
      <mat-expansion-panel *ngIf="(productCount > 0) && marketingPanels?.length" class="w-100"
        #expansionPanel="matExpansionPanel">
        <mat-expansion-panel-header>
          <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px" class="w-100">
            <div *ngIf="!expansionPanel.expanded" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px"
              fxLayoutPadding="5px" fxFlex [style.overflow]="'hidden'">
              <ng-container *ngFor="let panel of marketingPanels">
                <img *ngIf="imagetypes.includes(panel.fileContentType)" class="resource-image-thumbnail"
                  [src]="getFileDownloadUrl(panel) | auth | async">
                <mat-icon *ngIf="panel.fileContentType === 'video/mp4'" class="resource-image-thumbnail">ondemand_video</mat-icon>
              </ng-container>
            </div>
            <button mat-icon-button type="submit" color="accent" (click)="newReferenceInput.click()">
              <mat-icon matTooltip="Upload new file">upload</mat-icon>
              <input #newReferenceInput class="upload-input" id="add-new-reference-item" type="file" multiple
                (change)="onFileChosen($event)" onclick="value = null" [accept]="acceptedTypes.join(',')">
            </button>
          </div>
        </mat-expansion-panel-header>
        <div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="10px">
          <mat-card *ngFor="let panel of marketingPanels" class="w-100">
            <mat-card-content fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px" fx>
              <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                <div class="resource-file-container" fxLayoutAlign="center center">
                  <img *ngIf="imagetypes.includes(panel.fileContentType)" class="resource-image-thumbnail"
                    [src]="getFileDownloadUrl(panel) | auth | async">
                  <mat-icon *ngIf="panel.fileContentType === 'video/mp4'" class="resource-image-thumbnail">ondemand_video</mat-icon>
                </div>
                <span>{{panel?.fileName}}</span>
              </div>
              <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                <button mat-icon-button (click)="removeFile(panel)" color="accent" matTooltip="Remove File">
                  <mat-icon>delete</mat-icon>
                </button>
                <div>|</div>
                <button mat-icon-button (click)="download(panel)" color="accent" [disabled]="!panel?.fileHash"
                  matTooltip="Download File">
                  <mat-icon>file_download</mat-icon>
                </button>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </mat-expansion-panel>
    </mat-card-content>
  </mat-card>
</div>

<ng-template #marketingPanelTemplate let-mPanel let-only>

</ng-template>